import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      flexDirection: "column",
      display: "flex",
      padding: "32px 80px",
    },
    filter: {
      display: "flex",
      width: "100%",
      margin: "32px 0",
      gap: "40px",
      "& .MuiInputBase-root": {
        width: "391px",
      },
    },
    tabs: {
      width: "100%",
      borderBottom: "2px solid rgba(153, 153, 153, 0.4)",
      "& .Mui-selected": {
        borderBottom: "6px solid #7C9E3D",
      },
    },
    tabLabel: {
      fontSize: "16px",
      fontWeight: 700,
      textAlign: "center",
    },
  };
});
